/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"; 
import { Link } from "react-router-dom";

import homeIcon from "../../img/icon/icon-gnb-home.svg";
import deliveryIcon from "../../img/icon/icon-gnb-truck.svg";
import mypageIcon from "../../img/icon/icon-gnb-mypage.svg";

const Footer = ({varActiveMode}) => {

  return (
    <div id="gnb-menu-wrap">
      <ul className="gnb-menu">
        <li className={varActiveMode===1?"active":""}>
          <Link to="/Main"><div className="icon"><img src={homeIcon} alt=""/></div><span>홈</span></Link>
        </li>
        <li className="center">
          <Link to="/DeliveryState"><div className="icon"><img src={deliveryIcon} alt=""/></div><span>배차현황</span></Link>
        </li>
        <li className={varActiveMode===3?"active":""}>
          <Link to="/MyPage"><div className="icon"><img src={mypageIcon} alt=""/></div><span>마이페이지</span></Link>
        </li>
      </ul>
    </div>
  );
}
export default Footer;